import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

export const OrganizationSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    organizationId: Yup.string().nullable(),
    affiliateId: Yup.number().nullable(),
    companyName: Yup.string().nullable(),
    businessCategory: Yup.array().of(Yup.string()).nullable(),
    marketingChannels: Yup.array().of(Yup.string()).nullable(),
    taxId: Yup.string().nullable(),
  })
